module.exports = __webpack_public_path__ + "img/part5-dLBg3.34776050.png";